var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "hoverfill",
    cx: 25,
    cy: 25,
    r: 25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "content",
    d: "M22.1456 38.5416V26.8894H18.2085V22.2613H22.1456V18.6201C22.1456 14.6615 24.5844 12.5003 28.15 12.5003C29.3526 12.4952 30.5544 12.5579 31.7502 12.6882V16.8229H29.2764C27.3369 16.8229 26.9537 17.739 26.9537 19.0781V22.2613H31.332L30.7862 26.8894H26.9653V38.5416"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.c52eabc3f51b88d5ed6e95bfb176e59d.svg";
export { ForwardRef as ReactComponent };